export { createHttpClient, type HttpClient, type HttpClientConfig, type Method, type RequestOptions } from "./http/client";
export { ApiError, CLIENT_CODES, hasCode, isApiError, type FieldError } from "./http/errors";
export { parseFrame, readEventStream, type SseFrame } from "./http/sse";
export { saveResponse } from "./http/download";
export { assetUrl, createAttendeeApi, type AttendeeApi } from "./endpoints/public";
export { createStaffApi, type StaffApi } from "./endpoints/staff";
export { createSuperuserApi, type SuperuserApi } from "./endpoints/superuser";
export { CATALOG, type CatalogEntry, type Consumer } from "./catalog";
export * from "./wire/attendee";
export * from "./wire/event";
export * from "./wire/staff";
export * from "./wire/superuser";
export * from "./wire/survey";
export * from "./wire/walk-in";

/** `VITE_API_BASE_URL ?? "/v1"` (docs/frontend-integration.md 2.1). */
export function apiBaseUrl(): string {
  const fromEnv = import.meta.env.VITE_API_BASE_URL as string | undefined;
  return fromEnv && fromEnv.trim() ? fromEnv.trim() : "/v1";
}
